import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-favorite-list",
  templateUrl: "./favorite-list.component.html",
  styleUrls: ["./favorite-list.component.css"],
})
export class FavoriteListComponent implements OnInit {
  shimarStatus = true;
  favoriteData = [];
  apiParam = { slug: "home", limit: 20, offset: 0 };
  loadMore: boolean;
  viewMore: boolean;
  count: any;
  constructor(
    private service: BaseService,
    private route: Router,
    private toastr: ToastrService
  ) { }
  ngOnInit(): void {
    // if (!localStorage.getItem(environment.localStorageKey)) {
    //   this.route.navigate(["/"]);
    // } else {
    //   this.moreData();

    // }
           this.moreData();

  }
  moreData() {
    this.service.favoriteList(this.apiParam).subscribe(
      (data: any) => {
        if (data.results.length > 0) {
          this.favoriteData = this.favoriteData.concat(data.results);
          this.count = data.count;
          this.viewMore = true;
          this.shimarStatus = false;
          this.loadMore = false;
        } else {
          this.shimarStatus = false;
          this.loadMore = false;
          this.viewMore = false;
        }
      },
      (err: any) => {
        if (err.error.type === "INVALID_TOKEN" && err.error.code === 401) {
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
          localStorage.removeItem(environment.localStorageKey);
          this.route.navigate(["/"]);
          this.shimarStatus = false;
          this.loadMore = false;
          this.viewMore = false;
        } else {
          setTimeout(() => {
            this.shimarStatus = false;
            this.loadMore = false;
            this.viewMore = false;
          }, 2000);
        }
      }
    );
  }

  onScroll() {
    const offset = this.apiParam.limit + this.apiParam.offset;
    if (this.count > offset) {
      this.loadMore = true;
      if (this.favoriteData.length > 0 && this.viewMore) {
        this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
        this.moreData();
      }
    }
  }
}
